<template>
  <div class="open-applet" v-if="show">
    <img class="img" src="https://img3.quanyou.com.cn/joy/group1/M00/14/90/rB4ChmLugCCAbNwpAADrGsWjbpI893.png" alt="" />
    <div class="text">{{ $cache.getWxBinDing() ? '微信已成功绑定，请登录。' : '您还未绑定微信，请先绑定微信后登录。'}}</div>
    <van-button class="btn-box" round color="linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%)" @click="openApplet">
      {{$cache.getWxBinDing() ? '去登录' : '去绑定'}}
    </van-button>
  </div>
</template>

<script>
export default {
  computed: {
    query() {
      return this.$route.query
    },
  },
  
  data() {
    return {
      show: true
    }
  },
  created() {
    // 判断组件是否有缓存
    if (this.$vnode && this.$vnode.data.keepAlive) {
      return;
    } else {
      // 阻止H5自带返回键返回
      this.prevent_back();
    }
  },
  methods: {
    openApplet() {
      if (this.$cache.getWxBinDing()) {
        this.$router.replace({ path: '/init-page' });
      } else {
        if (this.query.source == 'my') {
          location.href= this.query.xcxLink
        } else {
          const loginInfo = this.$cache.getLoginInfo();
          location.href= loginInfo.xcxLink
        }
        
        this.$cache.setWxBinDing(true)
        this.show = false
        this.show = true
        
      }
    },
    prevent_back() {
      let path = this.$route.fullPath;
      // 判断是否开启了后端支持
      if (this.$router.mode == "hash") {
        path = "#" + path;
      }
      window.pushStateFun = function () {
        let state = {
          title: null,
          url: path, //要禁掉的页面
        };
        /* 
					三个参数：
					state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
					title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
					url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
				*/
        window.history.pushState(state, null, path); //要禁掉的页面
      };
      var state = {
        title: null,
        url: path, //要禁掉的页面
      };
      window.history.pushState(state, null, path); //要禁掉的页面
      window.addEventListener("popstate", window.pushStateFun, false);
    },
  },
  activated(){
    this.prevent_back();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", window.pushStateFun, false);
    next();
  }
}
</script>

<style lang="stylus" scoped>
  .open-applet {
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    width: 100%;
    height: 100vh;
    .img {
      width: 100%;
      height: 300px;
    }
    .text {
      margin: 20px 0;
    }
    .btn-box {
      width: 90%;
      margin: 0 20px;
    }
  }
</style>